export default "__VITE_ASSET__D66223mU__"